import { memo } from 'react';
import { Box, Button, Modal, SpaceBetween } from '@amzn/awsui-components-core';

interface FailedQualityCheckConfirmationModalProps {
  readonly onDismiss: () => void;
  readonly onConfirm: () => void;
}

export const FailedQualityCheckConfirmationModal = memo(
  function FailedQualityCheckConfirmationModal({
    onDismiss,
    onConfirm,
  }: FailedQualityCheckConfirmationModalProps) {
    return (
      <Modal
        visible
        header="Submit despite failed quality checks?"
        onDismiss={onDismiss}
        closeAriaLabel="Close modal"
        footer={
          <Box float="right">
            <SpaceBetween direction="horizontal" size="xs">
              <Button variant="link" onClick={onDismiss}>
                Cancel
              </Button>
              <Button variant="primary" onClick={onConfirm}>
                Submit for publisher review
              </Button>
            </SpaceBetween>
          </Box>
        }
      >
        Some quality check scans failed. Please review the content manually before proceeding.
      </Modal>
    );
  },
);
